import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { resolveNopeRefsFromKeys, every, resolveNopeRef } from './utils';

var NopePrimitive = /*#__PURE__*/function () {
  function NopePrimitive() {
    _classCallCheck(this, NopePrimitive);

    this.validationRules = [];
    this._type = 'undefined';
  }

  _createClass(NopePrimitive, [{
    key: "getType",
    value: function getType() {
      return this._type;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty(entry) {
      return entry === undefined || entry === null;
    }
  }, {
    key: "required",
    value: function required() {
      var _this = this;

      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'This field is required';

      var rule = function rule(entry) {
        if (_this.isEmpty(entry)) {
          return message;
        }
      };

      return this.test(rule);
    }
  }, {
    key: "when",
    value: function when(keys, conditionObject) {
      var ctxKeys = Array.isArray(keys) ? keys : [keys];

      var rule = function rule(_, context) {
        var resolvedConditionValues = resolveNopeRefsFromKeys(ctxKeys, context);

        var values = _toConsumableArray(resolvedConditionValues);

        var condIs = conditionObject.is;
        var result = typeof condIs === 'function' ? condIs.apply(void 0, _toConsumableArray(values)) : every(resolvedConditionValues, function (val) {
          return val === condIs;
        });
        return result ? conditionObject.then : conditionObject.otherwise;
      };

      return this.test(rule);
    }
  }, {
    key: "oneOf",
    value: function oneOf(options) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Invalid option';

      var rule = function rule(entry, context) {
        if (entry === undefined) {
          return;
        }

        var resolvedOptions = options.map(function (option) {
          return resolveNopeRef(option, context);
        });

        if (resolvedOptions.indexOf(entry) === -1) {
          return message;
        }
      };

      return this.test(rule);
    }
  }, {
    key: "notOneOf",
    value: function notOneOf(options) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Invalid Option';

      var rule = function rule(entry, context) {
        var resolvedOptions = options.map(function (option) {
          return resolveNopeRef(option, context);
        });

        if (resolvedOptions.indexOf(entry) !== -1) {
          return message;
        }
      };

      return this.test(rule);
    }
  }, {
    key: "test",
    value: function test(rule) {
      this.validationRules.push(rule);
      return this;
    }
    /**
     * @param entry - The value to be validated
     * @param context - Used for internal reference resolving. Do not pass this.
     */

  }, {
    key: "validate",
    value: function validate(entry, context) {
      var _iterator = _createForOfIteratorHelper(this.validationRules),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var rule = _step.value;
          var error = rule(entry, context);

          if (error instanceof NopePrimitive) {
            return error.validate(entry, context);
          } else if (error) {
            return error;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);

  return NopePrimitive;
}();

export default NopePrimitive;